import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import {
  vacanciesService,
  professionsService,
  MapedProfessionsType,
  competencesService,
  MapedCompetencesType,
  organizationsService,
  dictionaryService,
} from '@/services';
import { Providers, State } from './types';
import {
  FETCH_ITEMS,
  SET_ITEMS,
  SET_COUNT,
  FETCH_PROFESSIONS,
  SET_PROFESSIONS,
  INIT,
  FETCH_COMPETENCES,
  SET_COMPETENCES,
  FETCH_ORGANIZATIONS,
  SET_ORGANIZATIONS,
  FETCH_VACANCIES_PLACE_TYPE,
  SET_VACANCIES_PLACE_TYPE,
  FETCH_VACANCIES_EMPLOYMENT_TYPE,
  SET_VACANCIES_EMPLOYMENT_TYPE,
} from './consts';

const storeModule = ({ $api }: Providers) => {
  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class VacanciesListStore extends VuexModule<State, any> {
    items: Array<any> = [];
    count: number = 0;
    professions: MapedProfessionsType = [];
    competences: MapedCompetencesType = [];
    organizations: Array<any> = [];
    vacanciesPlaceType: Array<any> = [];
    vacanciesEmploymentType: Array<any> = [];
    isFirstRun: boolean = true;

    @Mutation
    [SET_ITEMS](items: any) {
      this.items = items;
    }

    @Mutation
    [SET_COUNT](value: any) {
      this.count = value;
    }

    @Mutation
    [SET_PROFESSIONS](data: MapedProfessionsType) {
      this.professions = data;
    }

    @Mutation
    [SET_COMPETENCES](data: MapedCompetencesType) {
      this.competences = data;
    }

    @Mutation
    [SET_ORGANIZATIONS](data: any) {
      this.organizations = data;
    }

    @Mutation
    [SET_VACANCIES_PLACE_TYPE](data: any) {
      this.vacanciesPlaceType = data;
    }

    @Mutation
    [SET_VACANCIES_EMPLOYMENT_TYPE](data: any) {
      this.vacanciesEmploymentType = data;
    }

    @Action
    async [INIT](params: any) {
      const { commit, dispatch } = this.context;

      if (!params) return;

      try {
        if (this.isFirstRun) {
          await Promise.all([
            dispatch(FETCH_ITEMS, params),
            dispatch(FETCH_PROFESSIONS),
            dispatch(FETCH_COMPETENCES),
            dispatch(FETCH_ORGANIZATIONS),
            dispatch(FETCH_VACANCIES_PLACE_TYPE),
            dispatch(FETCH_VACANCIES_EMPLOYMENT_TYPE),
          ]);
          this.isFirstRun = false;
        } else {
          await dispatch(FETCH_ITEMS, params);
        }
      } catch (err) {}
    }

    @Action
    async [FETCH_ITEMS](params: any) {
      const { commit } = this.context;

      try {
        const { filtered, data } = await vacanciesService($api).getVacancies(
          params,
        );

        commit(SET_ITEMS, data);
        commit(SET_COUNT, filtered ? filtered : data.length);
      } catch (e) {}
    }

    @Action
    async [FETCH_COMPETENCES](params: any) {
      const { commit } = this.context;

      try {
        const { filtered, data } = await competencesService(
          $api,
        ).getCompetences({});

        commit(SET_COMPETENCES, data);
      } catch (e) {
        commit(SET_COMPETENCES, []);
      }
    }

    @Action
    async [FETCH_ORGANIZATIONS](params: any) {
      const { commit } = this.context;

      try {
        const { filtered, data } = await organizationsService(
          $api,
        ).getOrganizationList({});

        commit(SET_ORGANIZATIONS, data);
      } catch (e) {
        commit(SET_ORGANIZATIONS, []);
      }
    }

    @Action
    async [FETCH_PROFESSIONS](params: any) {
      const { commit } = this.context;

      try {
        const { data } = await professionsService($api).getProfessions({});
        commit(SET_PROFESSIONS, data);
      } catch (err) {
        commit(SET_PROFESSIONS, []);
      }
    }

    @Action
    async [FETCH_VACANCIES_PLACE_TYPE](params: any) {
      const { commit } = this.context;

      try {
        const { data } = await dictionaryService($api).getVacanciesPlaceType();
        commit(SET_VACANCIES_PLACE_TYPE, data);
      } catch (err) {
        commit(SET_VACANCIES_PLACE_TYPE, []);
      }
    }

    @Action
    async [FETCH_VACANCIES_EMPLOYMENT_TYPE](params: any) {
      const { commit } = this.context;

      try {
        const { data } = await dictionaryService(
          $api,
        ).getVacanciesEmploymentType();
        commit(SET_VACANCIES_EMPLOYMENT_TYPE, data);
      } catch (err) {
        commit(SET_VACANCIES_EMPLOYMENT_TYPE, []);
      }
    }
  }

  return VacanciesListStore;
};

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/vacancies/list/store.ts